var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 701.84 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#00e676;}.c{fill:#212121;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 346.4,
    cy: 347.74,
    r: 329.79
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M504.42,428.35h-19.16v-.02h-113.12v55.47h42.46c-16.62,27.73-46.94,46.35-81.55,46.35-52.41,0-95.04-42.64-95.04-95.04s42.64-95.04,95.04-95.04c20.96,0,41.13,6.92,57.54,19.4,.25,.19,.61,.25,1.02,.25l38.49-38.49c-.07-.44-.23-.82-.55-1.09-26.85-22.54-60.95-35.13-96.5-35.13-82.76,0-150.1,67.33-150.1,150.1s67.33,150.1,150.1,150.1c50.2,0,94.72-24.78,121.99-62.75v43.16h54.83v-131.84c0-3.01-2.44-5.44-5.44-5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M464.94,209.23l-108.99-108.99c-6.09-6.09-14.07-9.13-22.05-9.12-7.98,0-15.96,3.03-22.05,9.12l-108.99,108.99c-12.16,12.16-12.16,31.87,0,44.02,6.08,6.08,14.04,9.12,22.01,9.12s15.93-3.04,22.01-9.12l68.11-68.11c10.42-10.42,27.31-10.42,37.73,0v-.07s.05,.04,.08,.07l68.11,68.11c6.08,6.08,14.04,9.12,22.01,9.12s15.93-3.04,22.01-9.12c12.16-12.16,12.16-31.87,0-44.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmiIcon);
export default __webpack_public_path__ + "static/media/GMI-icon.8fd003dc4460e11bd3e4eeaceff263af.svg";
export { ForwardRef as ReactComponent };